import React from 'react'
import { useHistory } from '@app/data'
import { List } from '../general/lists/websites-history'
import { useTranslation } from '@app/lib/hooks/useTranslation'
import { Paragraph } from '../stateless/typo/paragraph'

export const HistoryList = () => {
  const { data, loading, refetch } = useHistory()
  const { t } = useTranslation('settings')

  if ((!data || (data && !data.length)) && !loading) {
    return <Paragraph className='text-sm'>{t('history-empty')}</Paragraph>
  }

  return (
    <List
      data={data}
      loading={loading}
      refetch={refetch}
      emptyHeaderTitle={t('dashboard:empty-website')}
      emptyHeaderSubTitle={t('history-empty-details')}
    />
  )
}
